export default __webpack_public_path__ + "static/media/page16-screen-img.c37baecd.png";